// Submission of Public Land Application

<template>
  <div class="app-container justify-center pt-4 pb-5">
    <form
      id="lms4510"
      class="app-form lams-light border-main curved-1 shadow-dark"
      @submit.prevent
      :key="ts"
    >
      <!-- <Ul class="crumbs text-charcoal mb-2">
      <li><sym-link to="/">Home</sym-link></li>
      <li><sym-link to="lms1040">Portal</sym-link></li>
      <li><sym-link to="lms4500">Applications</sym-link></li>
      <li><span aria-current="page">Submit Land Application</span></li>
    </Ul> -->

      <div class="d-flex justify-between text-charcoal mt-3">
        <span class="display-7 bold mb-3"
          >Submission of Public Land Application</span
        >
      </div>

      <div
        class="short-help-box border-main mb-4 ivory curved sm-1 shadow-soft"
        v-show="helpInfo.shortHelpText"
      >
        <p class="mb-1 text-justify" v-html="helpInfo.shortHelpText"></p>

        <div class="text-right" v-show="helpInfo.helpText">
          <button
            type="button"
            class="warning darken-2 mb-1 sm-2 shadow"
            @click="onFormHelp"
            @mousedown="onButtonMouseDown"
          >
            Read more
          </button>
        </div>
      </div>

      <div class="mb-3">
        <p class="info text-center p-1 mb-1 curved">Location</p>
        <sym-combo
          plain
          vertical
          align="bottom"
          v-model="regionId"
          caption="Region"
          display-field="regionFullName"
          :tooltip="getToolTip('Region')"
          :datasource="regions"
          @changing="onRegionIdChanging"
          @changed="onRegionIdChanged()"
        ></sym-combo>
        <sym-combo
          plain
          vertical
          align="bottom"
          v-model="provinceId"
          caption="Province"
          display-field="provinceName"
          :tooltip="getToolTip('Province')"
          :datasource="provinces"
          @changing="onProvinceIdChanging"
          @changed="onProvinceIdChanged()"
          :key="ts1"
        ></sym-combo>
        <sym-combo
          plain
          vertical
          align="bottom"
          v-model="municipalityId"
          caption="Municipality"
          display-field="municipalityName"
          :tooltip="getToolTip('Municipality')"
          :datasource="municipalities"
          @changed="onMunicipalityIdChanged()"
        ></sym-combo>
        <sym-combo
          plain
          vertical
          align="bottom"
          v-model="barangayId"
          caption="Barangay"
          display-field="barangayName"
          :tooltip="getToolTip('Barangay')"
          :datasource="barangays"
          @changed="onBarangayIdChanged()"
        ></sym-combo>
        <sym-combo
          plain
          vertical
          align="bottom"
          v-model="officeId"
          caption="DENR Field Office"
          display-field="officeName"
          :tooltip="getToolTip('FieldOffice')"
          :datasource="offices"
        ></sym-combo>
        <!-- <sym-combo plain vertical align="bottom" v-model="applicationTypeId" caption="Application Type" display-field="applicationTypeName" :datasource="appTypes"></sym-combo>   -->
        <!-- <sym-combo plain vertical align="bottom" v-model="applicationTypeId" caption="Application Type" display-field="applicationTypeName" :datasource="appTypes"></sym-combo> -->

        <div class="assist-box">
          <!-- <sym-combo plain vertical align="bottom" v-model="app.applicationTypeId" caption="Application Type" display-field="applicationTypeName" :datasource="appTypes"></sym-combo> -->
          <sym-combo
            plain
            vertical
            align="bottom"
            v-model="applicationTypeId"
            caption="Application Type"
            :tooltip="getToolTip('ApplicationType')"
            display-field="applicationTypeName"
            :datasource="appTypes"
            @changing="onApplicationTypeIdChanging"
          ></sym-combo>
          <a
            href="javascript:void(0)"
            class="d-block text-right mt-2"
            @click="onAppTypeHelp"
            v-if="isAppTypeHelpEnabled"
            >Help me select</a
          >
        </div>

        <!-- <p class="info text-center p-1 mb-1 mt-4 curved">Lot Info</p> -->
        <p class="info text-center p-1 mb-1 mt-4 curved">
          Lot Survey Information
        </p>

        <div class="equal-width">
          <sym-text
            plain
            align="bottom"
            v-model="blockNumber"
            :tooltip="getToolTip('BlockNumber')"
            caption="Block Number"
          ></sym-text>

          <sym-text
            plain
            align="bottom"
            v-model="lotNumber"
            :tooltip="getToolTip('LotNumber')"
            caption="Lot Number"
          ></sym-text>
          <sym-dec
            plain
            align="bottom"
            v-model="area"
            :tooltip="getToolTip('Area')"
            caption="Area (sqm)"
            text-align="left"
          ></sym-dec>
        </div>

        <div class="equal-width align-items-end">
          <!-- <sym-combo
            plain
            vertical
            align="bottom"
            v-model="planPrefixId"
            :tooltip="getToolTip('SurveySymbol')"
            caption="Survey Symbol"
            
            :datasource="planPrefixes"
          ></sym-combo> -->
          <sym-text
            plain
            v-model="planPrefixId"
            align="bottom"
            :tooltip="getToolTip('SurveySymbol')"
            caption="Survey Symbols"
            list="SurveySymbol"
          ></sym-text>

          <datalist id="SurveySymbol">
            <option
              v-for="item in planPrefixes"
              :key="item.planPrefixId"
              :value="item.planPrefixId"
              class="optionContainer"
            ></option>
          </datalist>
          <sym-text
            plain
            align="bottom"
            v-model="planNumber"
            :tooltip="getToolTip('SurveyNumber')"
            caption="Survey Number"
          ></sym-text>
        </div>

        <sym-memo
          plain
          align="bottom"
          v-model="lotDetails"
          :tooltip="getToolTip('Remarks')"
          caption="Remarks"
          :inputHeight="3"
        ></sym-memo>

        <p class="info text-center p-1 mb-1 mt-4 curved">Personal Info</p>

        <sym-text
          plain
          align="bottom"
          v-model="lastName"
          caption="Last Name"
        ></sym-text>

        <sym-text
          plain
          align="bottom"
          v-model="firstName"
          caption="First Name"
        ></sym-text>
        <sym-text
          plain
          align="bottom"
          v-model="middleName"
          caption="Middle Name"
        ></sym-text>

        <!-- <sym-text plain align="bottom" v-model="applicantName" caption="Applicant Name"></sym-text> -->
        <sym-text
          plain
          align="bottom"
          v-model="spouseName"
          caption="Spouse Name"
        ></sym-text>

        <div class="equal-width">
          <sym-date
            plain
            align="bottom"
            v-model="birthDate"
            caption="Birth Date"
            @changing="onBirthDateChanging"
          ></sym-date>
          <sym-int
            plain
            align="bottom"
            v-model="age"
            caption="Age"
            text-align="left"
          ></sym-int>
        </div>

        <div class="equal-width">
          <sym-combo
            plain
            vertical
            align="bottom"
            v-model="genderId"
            caption="Gender"
            display-field="genderName"
            :datasource="genders"
          ></sym-combo>
          <sym-combo
            plain
            vertical
            align="bottom"
            v-model="civilStatusId"
            caption="Civil Status"
            display-field="civilStatusName"
            :datasource="civilStatus"
          ></sym-combo>
        </div>

        <p class="info text-center p-1 mb-1 mt-4 curved">Contact Info</p>

        <sym-text
          plain
          align="bottom"
          v-model="email"
          caption="Email"
          :tooltip="getToolTip('Email')"
          @changing="onEmailChanging"
        ></sym-text>
        <sym-text
          plain
          align="bottom"
          v-model="phoneNumber"
          caption="Phone Number (ex: 0921XXXXXXX)"
          :tooltip="getToolTip('PhoneNumber')"
          cue="99999999999"
          type="tel"
        ></sym-text>
        <sym-memo
          plain
          align="bottom"
          v-model="address"
          caption="Current Address"
          :tooltip="getToolTip('Address')"
        ></sym-memo>
        <sym-memo
          plain
          align="bottom"
          v-model="address1"
          caption="Permanent Address"
          :tooltip="getToolTip('Address1')"
        ></sym-memo>

        <button
          type="button"
          class="submit-button success w-100 text-center shadow lg-3 p-1 mt-3 mb-0"
          :disabled="!canSubmit"
          @click="onSubmit"
        >
          Submit &raquo;
        </button>
        <button
          type="button"
          class="primary text-center w-100 lg-1 shadow mt-3 mb-2"
          @click="goBack()"
        >
          <i class="fa fa-arrow-left mr-2"></i> Back
        </button>
      </div>
    </form>

    <sym-modal
      v-model="isFormHelpModalVisible"
      size="rg"
      :header="true"
      :customBody="true"
      :footer="false"
      :keyboard="true"
      :dismissible="true"
      title="Form Instructions"
      v-if="isFormHelpModalVisible"
      headerClass="darktan info-lightXXX"
      dismissButtonClass="danger"
    >
      <div class="help-box whitesmoke">
        <div v-html="helpInfo.helpText" class="lg-1"></div>

        <button
          type="button"
          class="primary text-center w-100 lg-1 shadow mt-2 mb-2"
          @click="isFormHelpModalVisible = false"
        >
          <i class="fa fa-arrow-left mr-2"></i>Back
        </button>
      </div>
    </sym-modal>

    <sym-modal
      v-model="isAppTypesModalVisible"
      size="rg"
      :header="true"
      :customBody="true"
      :footer="false"
      :keyboard="true"
      :dismissible="true"
      title="Application Type Details"
      v-if="isAppTypesModalVisible"
      headerClass="info-light"
      dismissButtonClass="danger"
    >
      <div class="assist-container">
        <div
          class="assist-item shadow-soft"
          v-for="(appType, index) in appTypes"
          :key="index"
          v-show="appType.applicationTypeId"
        >
          <div
            class="button info d-flex justify-between curved-bottom-0 py-1"
            @click="toggleAppType(index)"
          >
            <span class="lg-2 p-1">
              {{ appType.applicationTypeName }}
            </span>
            <i
              class="fa fa-chevron-circle-down fa-lg p-1"
              :class="{ 'fa-rotate-180': accordionAppTypes[index] }"
            ></i>
          </div>
          <sym-collapse
            class="border-lightgray curved-top-0 p-3"
            v-model="accordionAppTypes[index]"
          >
            <p class="lg-2" v-if="appType.applicationTypeInfo">
              {{ appType.applicationTypeInfo }}
            </p>
            <p
              class="lg-2 italic text-lightcoral"
              v-if="!appType.applicationTypeInfo"
            >
              Details not available
            </p>

            <div class="text-right">
              <button
                type="button"
                class="warning darken-2 shadow"
                @click="onSelectAppType(appType)"
              >
                <i class="fa fa-play mr-2"></i> Select
              </button>
            </div>
          </sym-collapse>
        </div>

        <button
          type="button"
          class="primary text-center w-100 lg-1 shadow mt-2 mb-2"
          @click="isAppTypesModalVisible = false"
        >
          <i class="fa fa-arrow-left mr-2"></i>Back
        </button>
      </div>
    </sym-modal>
  </div>
</template>

<script>
import { get, ajax } from "../../js/http";

import { DateTime } from "../../js/core";

import { appConfig } from "../../js/session";

import * as lams from "../../js/lams";

import PageBase from "../PageBase.vue";

export default {
  extends: PageBase,
  name: "lms4510",

  data() {
    return {
      ts1: 0,
      appId: -1,
      applicantName: "",
      lastName: "",
      firstName: "",
      middleName: "",
      spouseName: "",
      genderId: 0,
      civilStatusId: 0,
      address: "",
      address1: "",
      age: 0,
      birthDate: null,
      lotNumber: "",
      // claimant: '',
      area: 0,
      email: "",
      phoneNumber: "",

      applicationTypeId: "",
      planPrefixId: "",
      planNumber: "",
      blockNumber: "",
      lotDetails: "",

      regionId: 0,
      provinceId: 0,
      municipalityId: 0,
      barangayId: 0,
      officeId: "",

      genders: [],
      civilStatus: [],
      appTypes: [],
      planPrefixes: [],

      regions: [],
      provinces: [],
      municipalities: [],
      barangays: [],
      offices: [],
      appDetails: [],

      isAppTypeHelpEnabled: false,
      isAppTypesModalVisible: false,
      isFormHelpModalVisible: false,

      accordionAppTypes: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],

      helpInfo: {
        shortHelpText: "",
        helpText: "",
      },

      tooltipInfo: [],

      recaptcha: {
        siteKey: "",
        isHuman: false,
      },

      tooltipSample:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum",
      smsAppId: 0,
    };
  },

  computed: {
    canSubmit() {
      return true;
    },
  },

  methods: {
    // API calls

    // getToolTip (TooltipName) {
    //   const
    //     me = this,
    //     remarks = me.tooltipInfo.find( i => i.tooltipName === TooltipName);
    //     console.log(remarks);
    //   return ''
    // },

    getToolTip(TooltipName) {
      const me = this;

      let item = me.tooltipInfo.find((i) => i.tooltipName === TooltipName);

      if (item) {
        return item.remarks;
      } else {
        return "";
      }
    },

    getAccountInfo() {
      return get("api/accounts/" + this.accountCode);
    },

    getTooltip() {
      return get("api/gettooltip");
    },

    getFormHelp() {
      return get("api/plaformhelp");
    },

    getApplicationReferences() {
      return get("api/rgn/" + this.regionId + "/app-references");
    },

    getLinkStatus(regionId) {
      return get("api/regions/" + regionId + "/link-status");
    },

    getProvinces() {
      return get("api/rgn/" + this.regionId + "/provinces/online");
    },

    getMunicipalities() {
      const q = "regionId=" + this.regionId + "&provinceId=" + this.provinceId;
      return get("api/municipalities?" + q);
    },

    getBarangays() {
      const q =
        "regionId=" + this.regionId + "&municipalityId=" + this.municipalityId;
      return get("api/barangays?" + q);
    },

    getProvinceOffices() {
      return get(
        "api/rgn/" +
          this.regionId +
          "/provinces/" +
          this.provinceId +
          "/offices"
      );
    },

    getMunicipalityOffices() {
      return get(
        "api/rgn/" +
          this.regionId +
          "/municipalities/" +
          this.municipalityId +
          "/offices"
      );
    },

    getBarangayOffices() {
      return get(
        "api/rgn/" +
          this.regionId +
          "/barangays/" +
          this.barangayId +
          "/offices"
      );
    },

    getApplications() {
      return get(
        "api/rgn/" +
          this.regionId +
          "/accounts/" +
          this.accountCode +
          "/apps-lotinfo"
      );
    },

    getApplicationDetails() {
      return get(
        "api/rgn/" + this.regionId + "/appid/" + this.smsAppId + "/apps-details"
      );
    },

    // () {
    //  const
    //     options = this.core.getAjaxOptions('POST');

    getApplicationTypePrefix(applicationTypeId) {
      return get(
        "api/rgn/" +
          this.regionId +
          "/applicationTypeId/" +
          applicationTypeId +
          "/planPrefix"
      );
      // return get('api/rgn/' + this.regionId + '/provinces/jenon');
      // return get('api/rgn/' + this.regionId + '/planPrefix/' + applicationTypeId);

      // return get('api/rgn/' + this.regionId + '/applicationTypeId/jenon');
      // console.log('api/rgn/' + this.regionId + '/applicationTypeId/' + applicationTypeId + '/planPrefix');
      // return get('api/rgn/' + this.regionId + '/applicationTypeId/' + applicationTypeId + '/planPrefix');
      // console.log(123);
      // console.log(applicationTypeId);
      // return get('api/rgn/' + this.regionId + '/applicationTypeId/' + applicationTypeId + '/planPrefix');
      // return get('api/rgn/' + this.regionId + '/planPrefix');
    },

    sendMailNotification() {
      const me = this,
        toEmail = me.appDetails.email,
        accountName = me.appDetails.applicantName,
        subject = me.appDetails.applicationTypeName,
        id = me.smsAppId,
        message =
          "Your " +
          me.appDetails.applicationTypeName +
          " with Request Number " +
          me.smsAppId +
          " on lot " +
          me.appDetails.lotNumber +
          " Brgy " +
          me.appDetails.location +
          " is now submitted.",
        // url = window.location.origin + '/upload-documents?regionId=' + this.regionId + '&accountCode=' + me.sym.userInfo.accountCode + '&appId=' + me.smsAppId;
        url = window.location.origin + "/my-applications";

      // planPrefixId = me.appDetails.planPrefix,
      // planNumber = me.appDetails.planNumber,
      // area = me.appDetails.area,
      // lotNumber = me.appDetails.lotNumber,
      // blockNumber = me.appDetails.blockNumber,
      // locationInfo = me.appDetails.location,

      let payload = {
        toEmail: toEmail,
        accountName: accountName,
        subject: subject,
        id: id,
        message: message,
        url: url,
      };

      const body = JSON.stringify(payload),
        options = me.core.getAjaxOptions("POST", body);

      return ajax(
        "api/rgn/" + this.regionId + "/mail/" + this.smsAppId + "/notification",
        options
      );
    },

    InsertSMS() {
      const me = this,
        toEmail = me.appDetails.email,
        accountName = me.appDetails.applicantName,
        subject = me.appDetails.applicationTypeName,
        id = me.smsAppId,
        message =
          "Your " +
          me.appDetails.applicationTypeName +
          " with Request Number " +
          me.smsAppId +
          " on lot " +
          me.appDetails.lotNumber +
          " Brgy " +
          me.appDetails.location +
          " is now submitted",
        phoneNumber = "+63" + me.phoneNumber.substring(1, 11),
        url = window.location.origin + "/my-applications";
      // url = window.location.origin + '/upload-documents?regionId=' + this.regionId + '&accountCode=' + me.sym.userInfo.accountCode + '&appId=' + me.smsAppId;

      let payload = {
        toEmail: toEmail,
        accountName: accountName,
        subject: subject,
        id: id,
        message: message,
        phoneNumber: phoneNumber,
        url: url,
        regionId: this.regionId,
      };

      const body = JSON.stringify(payload),
        options = me.core.getAjaxOptions("POST", body);

      return ajax(
        "api/rgn/" + this.regionId + "/sms/" + this.smsAppId + "/notification",
        options
      );
    },

    // InsertSMS () {
    //   const
    //     me = this,
    //     toEmail = me.appDetails.email,
    //     accountName = me.appDetails.applicantName,
    //     subject =  me.appDetails.applicationTypeName,
    //     id = me.smsAppId,
    //     message = 'Your ' + me.appDetails.applicationTypeName + ' with Request Number ' + me.smsAppId + ' on lot ' + me.appDetails.lotNumber + ' Brgy ' +  me.appDetails.location + ' is now submitted',
    //     phoneNumber =  '+63' + me.phoneNumber.substring(1, 11),
    //     url = window.location.origin + '/my-applications'
    //     // url = window.location.origin + '/upload-documents?regionId=' + this.regionId + '&accountCode=' + me.sym.userInfo.accountCode + '&appId=' + me.smsAppId;

    //   let payload = {
    //     toEmail: toEmail,
    //     accountName: accountName,
    //     subject: subject,
    //     id: id,
    //     message: message,
    //     phoneNumber: phoneNumber,
    //     regionId: this.regionId,
    //     url: url

    //   };

    //   const
    //     body = JSON.stringify(payload),
    //     options = me.core.getAjaxOptions('POST', body);
    //     console.log('api/sms/' + this.smsAppId + '/notification',options);
    //     return ajax('api/sms/' + this.smsAppId + '/notification',options);
    //   // return ajax('api/rgn/' + this.regionId + '/sms/' + this.smsAppId + '/notification',options);
    // },

    createApplication() {
      const me = this;

      let payload = {
        accountId: me.accountId,
        accountName: me.accountName,
        accountEmail: me.accountEmail,
        accountPhoneNumber: me.accountPhoneNumber,
        accountAddress: me.accountAddress,
        accountTypeId: me.accountTypeId,
        accountCode: me.accountCode,

        appId: -1,
        officeId: me.officeId,
        applicantName: me.applicantName,
        lastName: me.lastName,
        firstName: me.firstName,
        middleName: me.middleName,
        spouseName: me.spouseName,
        genderId: me.genderId,
        civilStatusId: me.civilStatusId,
        address: me.address,
        address1: me.address1,
        age: me.age,
        birthDate: me.birthDate,
        lotNumber: me.lotNumber,
        claimant: me.applicantName,
        area: me.area,
        barangayId: me.barangayId,
        email: me.email,
        phoneNumber: me.phoneNumber,
        applicationTypeId: me.applicationTypeId,
        planPrefixId: me.planPrefixId,
        planNumber: me.planNumber,
        blockNumber: me.blockNumber,
        lotDetails: me.lotDetails,
      };

      const body = JSON.stringify(payload),
        options = me.core.getAjaxOptions("POST", body);

      return ajax("api/rgn/" + this.regionId + "/apps", options);
    },

    enlistAccount() {
      const me = this,
        options = me.core.getAjaxOptions("POST");

      return ajax(
        "api/accounts/" + me.accountCode + "/regions/" + me.regionId,
        options
      );
    },

    // event handlers

    onRegionIdChanging(e) {
      const me = this;

      let regionInfo = me.regions.find(
        (obj) => obj.regionId === e.proposedValue
      );
      e.message = `Region '${regionInfo.regionFullName}' is offline.`;

      if (!regionInfo.apiHostAddress && regionInfo.regionId) {
        e.preventDefault();
        return;
      }

      if (e.proposedValue) {
        e.callback = me.regionIdCallback;
      }
    },

    regionIdCallback(e) {
      const me = this,
        wait = me.wait();

      return me.getLinkStatus(e.proposedValue).then(
        (statusCode) => {
          me.stopWait(wait);

          let isOnline = statusCode === 200;
          return isOnline;
        },
        () => {
          me.stopWait(wait);
          return false;
        }
      );
    },

    onRegionIdChanged() {
      const me = this,
        wait = me.wait();

      me.provinces = [];
      me.municipalities = [];
      me.barangays = [];
      me.offices = [];

      if (!me.regionId) {
        me.stopWait(wait);
        return;
      }

      me.getProvinces()
        .then((data) => {
          me.provinces = data;

          if (me.provinces.length) {
            me.provinces.unshift({
              provinceId: 0,
              provinceName: "--- Select Province ---",
            });
            me.setFocus("provinceId");
          }
          if (!me.genders.length) {
            return me.getApplicationReferences();
          }
          return Promise.resolve(null);
        })
        .then((data) => {
          me.stopWait(wait);
          if (data) {
            me.genders = data.gender;
            me.civilStatus = data.civilStatus;
            me.appTypes = data.appType;
            me.planPrefixes = data.planPrefix;

            me.appTypes.unshift({
              applicationTypeId: "",
              applicationTypeName: "--- Select Application Type ---",
            });
          }
        })
        .catch((fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        });
    },

    onProvinceIdChanging(e) {
      const me = this;

      if (!e.proposedValue) {
        return;
      }

      let info = me.provinces.find((obj) => obj.provinceId === e.proposedValue);
      if (!info.officeCount) {
        e.message = `Province '${info.provinceName}' is offline.`;
        let mssg =
          `Province '${info.provinceName}' is currently not available for online transactions.` +
          "<hr>Please bear with us as we continue to upgrade our facilities to serve you better.";
        me.dialog.warning(mssg);
        e.preventDefault();
        me.ts1 += 1;
      }
    },

    onProvinceIdChanged() {
      const me = this,
        wait = me.wait();

      me.municipalities = [];
      me.barangays = [];
      me.offices = [];

      if (!me.provinceId) {
        me.stopWait(wait);
        return;
      }

      me.getMunicipalities()
        .then((data) => {
          me.municipalities = data;
          me.municipalities.unshift({
            municipalityId: 0,
            municipalityName: "--- Select Municipality ---",
          });
          return me.getProvinceOffices();
        })
        .then((data) => {
          me.stopWait(wait);
          me.candidateOffices = data;
          me.candidateOffices.unshift({
            officeId: "",
            officeName: "--- Select Field Office ---",
          });
          me.setFocus("municipalityId");
        });
    },

    onMunicipalityIdChanged() {
      const me = this,
        wait = me.wait();

      me.barangays = [];
      me.offices = [];

      if (!me.municipalityId) {
        me.stopWait(wait);
        return;
      }

      me.getBarangays()
        .then((data) => {
          me.barangays = data;
          me.barangays.unshift({
            barangayId: 0,
            barangayName: "--- Select Barangay ---",
          });
          return me.getMunicipalityOffices();
        })
        .then((data) => {
          me.stopWait(wait);
          if (data && data.length) {
            me.candidateOffices = data;
            me.candidateOffices.unshift({
              officeId: "",
              officeName: "--- Select Field Office ---",
            });
          }
          me.setFocus("barangayId");
        });
    },

    onBarangayIdChanged() {
      const me = this,
        wait = me.wait();

      me.offices = [];

      if (!me.barangayId) {
        me.stopWait(wait);
        return;
      }

      me.getBarangayOffices().then((data) => {
        me.stopWait(wait);
        if (data && data.length) {
          me.candidateOffices = data;

          if (data.length == 1) {
            me.officeId = me.candidateOffices[0].officeId;

            me.setFocus("officeId");
          }
        }

        // me.setFocus('barangayId');
      });

      Object.assign(me.offices, me.candidateOffices); // me.offices = data;
    },

    onApplicationTypeIdChanging(e) {
      if (e.proposedValue) {
        e.callback = this.applicationTypeIdCallback;
      }

      //JENON

      // console.log(this.applicationTypeId);
      // this.getApplicationTypePrefix(this.applicationTypeId)

      // .then( data => {
      //   console.log(data);
      //   if (data) {
      //       this.planPrefixes = data;
      //       }
      //   })
    },

    applicationTypeIdCallback(e) {
      const me = this;

      e.messageDuration = 1;
      e.suppressMessage = true;
      let appType = me.appTypes.find(
        (o) => o.applicationTypeId === e.proposedValue
      );
      if (appType && appType.applicationTypeInfo) {
        return me.dialog
          .confirm(
            "<b>" +
              appType.applicationTypeName +
              "</b><hr>" +
              appType.applicationTypeInfo +
              "<br><br>Select this application type?<br>",
            { title: "Confirm Selection", scheme: "warning", size: "rg" }
          )
          .then((reply) => {
            // this.getApplicationTypePrefix(appType.applicationTypeId)

            // .then( data => {

            //   // console.log(!data.length == 0);
            //   if (data) {
            //     // console.log(data.length == 0);
            //     // console.log(data.length === 0);
            //     // console.log(data.length = 0);

            //     this.planPrefixes = data;
            //       }
            //   })

            return reply === "yes";
          });
      }
    },

    onBirthDateChanging(e) {
      if (e.proposedValue instanceof DateTime) {
        let p = e.proposedValue,
          today = DateTime.now();

        if (p.year < 1920) {
          e.preventDefault();
          return;
        }

        if (p > today) {
          e.preventDefault();
          return;
        }
      }
    },

    onEmailChanging(e) {
      if (!e.proposedValue) {
        return;
      }

      if (!this.core.isValidEmail(e.proposedValue)) {
        e.message = "(" + e.proposedValue + ") is not a valid email address.";
        e.preventDefault();
        return;
      }
    },

    onSubmit() {
      const me = this;

      if (!me.isValid(me.$options.name)) {
        me.advice.fault("Fill in the required fields (marked in red).", {
          duration: 5,
        });
        return;
      }

      let newAppId,
        wait = me.wait();

      me.getApplications()
        .then((apps) => {
          me.apps = apps;
          if (me.hasDuplicateApplication()) {
            return me.dialog.fault(
              "You already submitted an application for lot <b>" +
                me.lotNumber +
                "</b>.<hr>Submission of duplicate application for the same lot is not allowed."
            );
          }
          return me.createApplication();
        })
        .then((appId) => {
          if (me.core.isNumber(appId) && appId) {
            newAppId = appId;
            return me.enlistAccount();
          }
          return Promise.resolve(false);
        })
        .then((success) => {
          me.stopWait(wait);

          if (success) {
            this.smsAppId = newAppId;
            let message =
              "Thank you for submitting your application. Please upload your supporting documents (in PDF format) to proceed with your application. Your transaction number will be sent to you via SMS/email once supporting documents are verified. Please note that the allowable processing time with a maximum of 102 working days will only start once transaction number has been issued." +
              "<br><br>Next step is uploading of supporting documents (in PDF format).";
            me.dialog.success(message).then(() => {
              me.goUploadPage(newAppId);
            });
          }

          me.getApplicationDetails().then(
            (info) => {
              me.stopWait(wait);
              if (info) {
                me.appDetails = info.appdetails[0];
                me.sendMailNotification();
                me.InsertSMS();
              }
            },
            (fault) => {
              me.stopWait(wait);
              me.showFault(fault);
            }
          );
        })
        .catch((fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        });
    },

    onSelectAppType(appType) {
      this.applicationTypeId = appType.applicationTypeId;
      this.isAppTypesModalVisible = false;
    },

    onAppTypeHelp() {
      const me = this;

      if (me.appTypes.length) {
        me.toggleAppTypeAll(false);
        me.isAppTypesModalVisible = true;
      }
    },

    onFormHelp() {
      this.isFormHelpModalVisible = true;
    },

    onButtonMouseDown(e) {
      e.preventDefault();
    },

    // helpers

    goUploadPage(appId) {
      let route = {
        name: "lms4520",
        query: {
          regionId: this.regionId,
          accountCode: this.accountCode,
          appId: appId,
        },
      };

      this.go(route);
    },

    hasDuplicateApplication() {
      const me = this;

      let index = me.apps.findIndex(
        (o) =>
          o.lotNumber === me.lotNumber &&
          o.blockNumber === me.blockNumber &&
          o.barangayId === me.barangayId &&
          o.planPrefixId === me.planPrefixId &&
          o.planNumber === me.planNumber
      );

      return index > -1;
    },

    toggleAppType(index) {
      const me = this;
      me.$set(me.accordionAppTypes, index, !me.accordionAppTypes[index]);
    },

    toggleAppTypeAll(flag) {
      const me = this;

      me.accordionAppTypes.forEach((element, index) => {
        me.accordionAppTypes[index] = flag;
      });
    },
  },

  created() {
    this.accountId = 0;
    this.accountName = "";
    this.accountCode = "";
    this.accountEmail = "";
    this.accountPhoneNumber = "";
    this.accountAddress = "";
    this.accountTypeId = 0;
    this.candidateOffices = [];
    this.apps = [];
  },

  mounted() {
    const me = this,
      userInfo = me.sym.userInfo;

    me.accountId = userInfo.accountId;
    me.accountName = userInfo.userName;
    me.accountCode = userInfo.accountCode;
    me.accountTypeId = userInfo.accountTypeId;
    me.applicantName = userInfo.userName;

    me.isAppTypeHelpEnabled = appConfig.isAppTypeHelpEnabled;

    me.regions = lams.getRegionList().filter((o) => o.apiHostAddress);

    me.regions.unshift({
      regionId: 0,
      regionFullName: "--- Select Region ---",
    });

    // //jenon
    //     me.getApplicationTypePrefix()
    //       .then( data => {
    //         if (data) {
    //           me.planPrefixes = data;
    //           }
    //       })

    me.setRequiredMode(
      "regionId",
      "provinceId",
      "municipalityId",
      "barangayId",
      "officeId",
      "genderId",
      "civilStatusId",
      "applicantName",
      "lastName",
      "firstName",
      "birthDate",
      "age",
      "lotNumber",
      "area",
      "phoneNumber",
      "address",
      "address1",
      "applicationTypeId",
      "planPrefixId",
      "planNumber"
      // 'blockNumber',
      // 'lotDetails'
    );

    me.getFormHelp().then((help) => {
      if (help && help.length) {
        me.helpInfo.shortHelpText = help[0].plaFormShortHelpText;
        me.helpInfo.helpText = help[0].plaFormHelpText;
      }
    });

    me.getTooltip().then((info) => {
      if (info && info.length) {
        me.tooltipInfo = info;
      }
    });

    me.getAccountInfo().then((info) => {
      let acctInfo = me.core.convertDates(info[0]);

      if (acctInfo.birthDate === null) {
        me.birthDate = me.core.emptyDateTime();
      } else {
        me.birthDate = acctInfo.birthDate;
      }
      if (acctInfo.age === null) {
        me.age = 0;
      } else {
        me.age = acctInfo.age;
      }
      me.email = acctInfo.email;
      me.phoneNumber = acctInfo.phoneNumber;
      me.address = acctInfo.address;

      me.accountEmail = acctInfo.email;
      me.accountPhoneNumber = acctInfo.phoneNumber;
      me.accountAddress = acctInfo.address;

      me.$nextTick(() => {
        setTimeout(() => {
          me.setFocus("regionId");
        }, 500);
      });
    });
  },
};
</script>

<style scoped>
.app-container {
  display: flex;
}

.app-container >>> .form-control {
  margin-bottom: 2px;
}

.app-container >>> .input-tag {
  padding-bottom: 2px;
  margin-left: 2px;
}

.app-form {
  width: 40%;
  padding: 1rem 2rem;
}

.equal-width {
  display: flex;
}

.equal-width > * {
  flex: 1;
}

.equal-width > :not(:last-child) {
  margin-right: 0.5rem;
}

.equal-width :last-child {
  margin-right: 0;
}

.assist-box a {
  text-decoration: none;
}

.assist-container {
  padding: 1.5rem;
}

.assist-item {
  display: inline-block;
  width: 100%;
  background: white;
  margin-bottom: 1rem;
}

.short-help-box {
  padding: 1rem 1.125rem;
}

.help-box {
  padding: 1.5rem 2rem;
}
.optionContainer {
  width: 100%;
  padding: 10px;
  background-color: seagreen;
}

@media (max-width: 1024px) {
  .app-form {
    width: 60%;
  }
}

@media (max-width: 840px) {
  .app-form {
    width: 70%;
  }
}

@media (max-width: 700px) {
  .app-form {
    width: 80%;
    padding: 1.25rem;
  }
}

@media (max-width: 576px) {
  .assist-container {
    padding: 0.25rem;
  }

  .assist-item {
    margin-bottom: 0.5rem;
  }
}

@media (max-width: 480px) {
  .app-form {
    width: 90%;
    padding: 1rem 1rem;
  }

  .submit-button {
    margin-top: 0.5rem !important;
  }

  .help-box {
    padding: 1.25rem 1.5rem;
  }
}

@media (max-width: 384px) {
  .app-form {
    padding: 0.75rem;
  }
  .recaptcha-container {
    transform: scale(0.9);
  }
  .short-help-box {
    padding: 0.75rem 1rem;
  }
}

@media (max-width: 320px) {
  .app-form {
    width: 96%;
    padding: 0.5rem;
  }
  .recaptcha-container {
    transform: scale(0.9);
  }
  .help-box {
    padding: 1rem 1.25rem;
  }
}
</style>
